import { Button, Grid, TextField, Select, MenuItem, FormHelperText, InputLabel, Checkbox, FormControlLabel } from '@mui/material';
import { useFormik } from 'formik';
import { React, useEffect, useState } from 'react'
import { allTimezones } from 'react-timezone-select';

import * as yup from 'yup';

export default function PartnerForm(props) {
    const [isImageAllowed, setIsImageAllowed] = useState(false);
    const [logoError, setLogoError] = useState("");
    const [logoValidating, setLogoValidating] = useState(false);
    const [imageName, setImageName] = useState(null);
    const [isAddOperation, setIsAddOperation] = useState(false);
    const [timezones, setTimezones] = useState([]);

    const [recvValues, setRecvValues] = useState({
        id: '', partnerName: '',
        contact: '',
        mypreorderid: '',
        entrykey: '',
        expiry_date: '',
        timeZone: '',
        logo: ''
    });
    useEffect(() => {
        // Transform allTimezones into options with labels
        const options = Object.entries(allTimezones).map(([value, label]) => ({
            value,
            label: `${label} [${value}]`
        }));
        setTimezones(options);
    }, []);
    useEffect(() => {

        if (props.selectedRow !== null)//&& valueLoaded === false)
        {
            console.log("Partner Edit" + JSON.stringify(props.selectedRow));
            setRecvValues({
                id: props.selectedRow.id,
                partnerName: props.selectedRow.name || '',
                contact: props.selectedRow.key_contacts,
                mypreorderid: props.selectedRow.mypreorderid ?? props.selectedRow.myPreorderId ?? props.selectedRow.my_preorder_id ?? '',
                entrykey: props.selectedRow.entrykey || '',
                expiry_date: props.selectedRow.expiry_date || '',
                timezone: props.selectedRow.timezone ?? props.selectedRow.timeZone ?? '',
                logo: props.selectedRow.logo
            });
            setImageName(props.selectedRow.logo);
            setIsAddOperation(false);
        }
        else {
            setRecvValues({
                id: '', partnerName: '',
                contact: '',
                mypreorderid: '',
                entrykey: '',
                expiry_date: '',
                timezone: '',
                logo: ''
            });
            setIsAddOperation(true);
            setImageName("");
        }

    }, [props.selectedRow]);

    const validationSchema = yup.object({
        partnerName: yup
            .string()
            .required('Name is required'),
        contact: yup
            .string()
            .required('Key contact is required'),
        mypreorderid: yup
            .string()
            .required('MyPreorder ID is required'),
        entrykey: yup
            .string()
            .required('Entry key is required'),
        expiry_date: yup
            .string()
            .required('Membership Expiry Date is required'),
        timezone: yup
            .string()
            .required('Timezone is required'),
    });
    function readImageFile(file) {
        setLogoValidating(true);
        var reader = new FileReader(); // CREATE AN NEW INSTANCE.

        reader.onerror = function () {
            setLogoValidating(false);
            setIsImageAllowed(false);
            setLogoError("Could not read the selected image.");
        };

        reader.onload = function (e) {
            var img = new Image();
            img.src = e.target.result;

            img.onerror = function () {
                setLogoValidating(false);
                setIsImageAllowed(false);
                setLogoError("Could not read the selected image.");
            };

            img.onload = function () {
                var w = this.width;
                var h = this.height;
                setLogoValidating(false);
                if (w > 100 || h > 80) {
                    setIsImageAllowed(false);
                    setLogoError("Logo must be at most 100 x 80 pixels (PNG or JPG). Selected image is " + w + " x " + h + " px.");
                } else {
                    formik.setFieldValue("logo", file);
                    setIsImageAllowed(true);
                    setLogoError("");
                }
            }
        }
        reader.readAsDataURL(file);
    };
    function onCancelForm() {
        //alert("Cancel");
        props.handleSubmit(null, isAddOperation, true)
    }

    const formik = useFormik({
        enableReinitialize: true,
        validateOnMount: true,
        validationSchema: validationSchema,
        initialValues: {
            id: recvValues?.id || '',
            partnerName: recvValues?.partnerName || '',
            contact: recvValues?.contact || '',
            mypreorderid: recvValues?.mypreorderid || '',
            entrykey: recvValues?.entrykey || '',
            expiry_date: recvValues?.expiry_date || '',
            timezone: recvValues?.timezone || '',
            logo: recvValues?.logo || '',
            // "Copy as redemption partner" checkbox (add-only). true/false.
            rpFlag: false
            // image:recvValues?.image || null,
        },

        onSubmit: (values) => {
            console.log(values.logo);

            const isNewImageUploaded = typeof values.logo === 'object' && values.logo !== null;

            if (isAddOperation || isNewImageUploaded) {
                if (values.logo === "" || values.logo === undefined || values.logo === null) {
                    setLogoError("Please select a logo image.");
                    return;
                }
                if (isImageAllowed === false) {
                    setLogoError("Logo must be at most 100 x 80 pixels (PNG or JPG).");
                    return;
                }
            }
            if (values.partnerName === '')
                props.handleSubmit(null, isAddOperation, true);
            else {

                props.handleSubmit(values, isAddOperation, false);
            }
            //this.resetForm();

        },
        // onReset:(values)=>{
        //     alert("Onreset");

        //     props.handleSubmit(null,isAddOperation,true)
        // }
    });

    return (
        // <Grid style={{ borderStyle: 'solid', borderColor: 'pink' }} container item spacing={3} xs={12}
        // direction="column" alignItems='flex-start' >
        // <Paper >
        <form onSubmit={formik.handleSubmit} >
            {/* <Grid container spacing={2}> */}
            <Grid item container xs={12} spacing={2}
                justifyContent="flex-start" style={{ borderStyle: 'none', borderColor: 'black' }}
                alignItems='flex-start' direction="row">
                {/* <Grid container spacing={{xs:2,md:5}} direction="row" columns={{xs:4,sm:8,md:12}}> */}
                <Grid item xs={12} sm={12} md={12}  >
                </Grid>
                <Grid item xs={12} sm={4} md={5}  >
                    <TextField
                        required
                        fullWidth
                        variant='outlined'
                        id="partnerName"
                        name="partnerName"
                        label="Name"
                        disabled={!isAddOperation}
                        value={formik.values.partnerName}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        error={formik.touched.partnerName && Boolean(formik.errors.partnerName)}
                        helperText={formik.touched.partnerName && formik.errors.partnerName}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={5}  >
                    <TextField
                        required
                        fullWidth
                        variant='outlined'
                        id="partnerContact"
                        name="contact"
                        label="Key contact (Name and phone number)"
                        value={formik.values.contact}
                        onChange={formik.handleChange}
                        error={formik.touched.contact && Boolean(formik.errors.contact)}
                        helperText={formik.touched.contact && formik.errors.contact}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={5}>
                    <TextField
                        required
                        fullWidth
                        variant='outlined'
                        id="mypreorderid"
                        name="mypreorderid"
                        label="MyPreorder ID"
                        value={formik.values.mypreorderid}
                        onChange={formik.handleChange}
                        error={formik.touched.mypreorderid && Boolean(formik.errors.mypreorderid)}
                        helperText={formik.touched.mypreorderid && formik.errors.mypreorderid}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={5}>
                    <TextField
                        required
                        fullWidth
                        variant='outlined'
                        id="entrykey"
                        name="entrykey"
                        label="Entry Key"
                        value={formik.values.entrykey}
                        onChange={formik.handleChange}
                        error={formik.touched.entrykey && Boolean(formik.errors.entrykey)}
                        helperText={formik.touched.entrykey && formik.errors.entrykey}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={5}>
                    <TextField
                        required
                        fullWidth
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                        id="expiry_date"
                        name="expiry_date"
                        label="Membership Expiry Date"
                        value={formik.values.expiry_date}
                        onChange={formik.handleChange}
                        error={formik.touched.expiry_date && Boolean(formik.errors.expiry_date)}
                        helperText={formik.touched.expiry_date && formik.errors.expiry_date}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={5}  >
                    {/* <TextField
                                    fullWidth
                                    variant='outlined'
                                    id="partnerContact"
                                    name="contact"
                                    label="Contact"
                                    value={formik.values.contact}
                                    onChange={formik.handleChange}
                                    error={formik.touched.contact && Boolean(formik.errors.contact)}
                                    helperText={formik.touched.contact && formik.errors.contact}
                                /> */}
                    <TextField
                        required
                        select
                        fullWidth
                        variant='outlined'
                        id="timezone"
                        name="timezone"
                        label="Timezone"
                        value={formik.values.timezone || ''}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.timezone && Boolean(formik.errors.timezone)}
                        helperText={formik.touched.timezone && formik.errors.timezone}
                    >
                        {timezones.map((tz) => (
                            <MenuItem key={tz.value} value={tz.value}>
                                {tz.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={4} md={5}  >
                    <div className="form-group">
                        <span style={{ marginRight: 8 }}>Logo: </span>
                        <Button variant="outlined" component="label" size="small" style={{ textTransform: 'none', marginRight: 8 }}>
                            Choose File
                            <input
                                name="image"
                                type="file"
                                accept='image/png, image/jpeg'
                                hidden
                                onChange={(event) => {
                                    const file = event.currentTarget.files[0];
                                    if (!file) return;
                                    setLogoError("");
                                    formik.setFieldValue("logo", file);
                                    setImageName(file.name);
                                    readImageFile(file);
                                }}
                            />
                        </Button>
                        {/* Show the chosen/existing file name. "No file chosen" only for Add. */}
                        <span>{imageName || (isAddOperation ? 'No file chosen' : '')}</span>
                        {/* <Thumb file={values.file} /> */}
                    </div>
                    {logoValidating && <FormHelperText>Checking image…</FormHelperText>}
                    {logoError && <FormHelperText error>{logoError}</FormHelperText>}
                    {/* <TextField
                                    fullWidth
                                    variant='outlined'
                                    id="image"
                                    name="image"
                                    label="Logo"
                                    type="file"
                                    // value={file}
                                    onChange={(event)=> formik.setFieldValue("image", event.currentTarget.files[0])}
                                    inputProps={{accept:"image/png, image/jpeg"}}
                                /> */}
                </Grid>

                {isAddOperation && (
                    <Grid item xs={12} sm={8} md={10}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id="rpFlag"
                                    name="rpFlag"
                                    checked={Boolean(formik.values.rpFlag)}
                                    onChange={(e) => formik.setFieldValue('rpFlag', e.target.checked)}
                                />
                            }
                            label="Copy as redemption partner"
                        />
                    </Grid>
                )}

            </Grid>
            <Grid container item xs={12}
                direction="row" spacing={3}
                style={{ borderStyle: 'none', borderColor: 'black', marginTop: 24 }} justifyContent='flex-start'>
                <Grid item >
                    <Button type='submit' color='primary' variant='contained' disabled={logoValidating || !formik.isValid || (isAddOperation && !isImageAllowed)}>Submit</Button>
                </Grid>
                <Grid item>
                    <Button type='button' onClick={onCancelForm} color='secondary' variant='contained'>Cancel</Button>
                </Grid>
            </Grid>
            {/* </Grid> */}
        </form>
        // </Paper>
        // </Grid>


    );
}